import Vue from 'vue';
import axios from 'axios';
import progressDialog from '@/components/progress-dialog/progressDialog.vue';
import { MediaQueries } from 'vue-media-queries';
import VueFlashMessage from 'vue-flash-message';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import theme from './plugins/theme';
import { applyCookieCredentials } from './service/authStrategy';

require('vue-flash-message/dist/vue-flash-message.min.css');

const mediaQueries = new MediaQueries();

Vue.use(mediaQueries);
Vue.use(progressDialog);
Vue.use(VueFlashMessage);
Vue.use(theme);

Vue.config.productionTip = false;

axios.interceptors.request.use((config) => applyCookieCredentials(config));

new Vue({
  router,
  store,
  vuetify,
  mediaQueries,
  render: (h) => h(App),
}).$mount('#app');
